import { map, Observable, timer, zip } from 'rxjs';

export const DEFAULT_MIN_LOADING_MS = 250;

/**
 * Holds a source's first value until at least `ms` have passed.
 *
 * For loading states: when a response comes back in ~40ms the skeleton appears and vanishes
 * again within a frame or two, which reads as a glitch — worse than never showing it. Pacing
 * the emission keeps the skeleton on screen long enough to be understood as loading.
 *
 * Intended for one-shot sources (an HTTP call / promise). `zip` pairs emissions one-to-one,
 * so a source that emits repeatedly would be throttled to the timer rather than delayed —
 * not what you want; use `delay`-style operators there instead.
 *
 *   mergeMap(({ year }) => from(api.getStats(year)).pipe(notFasterThan()))
 */
export const notFasterThan =
  <T>(ms: number = DEFAULT_MIN_LOADING_MS) =>
  (source: Observable<T>): Observable<T> =>
    zip(source, timer(ms)).pipe(map(([value]) => value));
